import changes from 'Dummy/changelog'
import { connect } from 'react-redux'
import { useEffect, useState } from 'react'
import { Typography, Space, Badge, Button, Card, Descriptions, Modal, Tag, Timeline, Tooltip, Tabs } from 'antd'
import { useHotKeys } from 'Hooks'
import { Loading, ChangelogList } from 'Components'
import { isBirthday, wasNewVersionReleased } from 'Services/WeaverUtils'
import changelog from 'Dummy/changelog'
import './ChangelogButton.scss'
import axios from 'axios'
import sdkChangelog from 'weaver-sdk/CHANGELOG.md'
import party from 'party-js'
import { LogoMain, Mark } from 'wvrio-styleguide'

{ Text } = Typography

ChangelogButton = ({ collapsed, hideChangelog }) ->
  sdkInfo = {
    url: sdkChangelog
    keyId: 'sdkChangelist'
    tabTitle: 'JavaScript SDK'
    hasCurrentVersion: true
  }
  dbInfo = {
    keyId: 'dbChangelist'
    tabTitle: 'Reaver'
    hasCurrentVersion: false
  }
  serverInfo = {
    keyId: 'serverChangelist'
    tabTitle: 'Weaver Server'
    hasCurrentVersion: false
  }

  changelistObjs = [sdkInfo, serverInfo, dbInfo]

  { TabPane } = Tabs

  [visible, setVisible] = useState(false)
  [sdkVersion, setSdkVersion] = useState()
  [serverVersion, setServerVersion] = useState()
  [connectorVersion, setConnectorVersion] = useState()

  useHotKeys([{
    sequence: 'esc'
    fn: -> setVisible(undefined)
    expr: visible
    temporary: true
    watchers: [visible]
  }])

  useEffect(->
    (->
      setSdkVersion(Weaver.getInstance().version())
      setServerVersion(await Weaver.getInstance().serverVersion())
      setConnectorVersion(await Weaver.getCoreManager().connectorVersion())
    )()
    undefined
  , [])

  useEffect(->
    if visible and isBirthday()
      element = document.querySelector('.changelog')
      party.element(element, {
        count: 250
      })
    undefined
  , [visible])

  openModal = ->
    setVisible(true)
    localStorage.setItem('mostRecentSeenVersion', _.keys(changelog)[0])

  logoStyle = { height: 18 }

  ModalFooter =
    <Space>
      <Text type="secondary"><b>SDK:</b> { sdkVersion }</Text>
      <Text type="secondary"><b>Server:</b> { serverVersion }</Text>
      <Text type="secondary"><b>Connector:</b> { connectorVersion }</Text>
    </Space>

  <>
    <Tooltip title={if not hideChangelog then "Release Notes"} placement="left">
      <Button
        data-testid="release-notes-button"
        type="text"
        shape={'circle' if collapsed }
        icon={if collapsed then <Mark style={{ height: 16, marginLeft: 4 }} /> else <LogoMain style={{ height: 18, width: 100, marginLeft: -32 }} />}
        onClick={if not hideChangelog then openModal}
      >
      </Button>
    </Tooltip>

    <Modal
      visible={visible}
      onCancel={ -> setVisible(false)}
      centered={true}
      width={Math.max(800, window.innerWidth / 2)}
      footer={ModalFooter}
      style={
        marginTop: '3vh'
      }
      bodyStyle={{
        maxHeight: '82vh'
        overflow: 'auto'
      }}
      title="Release Notes"
      className="changelog"
    >
      <Tabs defaultActiveKey="wvr.io" style={{ background: 'inherit' }}>
        <TabPane tab="User Interface" key="wvr.io">
          <Timeline style={{ marginLeft: 76, paddingTop: 25 }} mode='left'>
            {
              _.map(changes, (data, version) ->
                versionChanges = [
                  data.feature.map((text) -> { text, type: 'New', color: 'green' })...
                  data.improvement.map((text) -> { text, type: 'Improved', color: 'gold' })...
                  data.fix.map((text) -> { text, type: 'Fixed', color: 'volcano' })...
                ]
                <Timeline.Item key={version} style={{ margin: '0 0 0 30px'}}>
                  <span style={{
                    left: -135,
                    top: 1,
                    position: 'relative',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: 'inline-block',
                    whiteSpace: 'nowrap',
                    width: 105
                  }}>{ data.date }</span>
                  <div className="triangle" />
                  <Card
                    title="v#{version}"
                    bordered={false}
                    style={{
                      position: 'relative',
                      top: -39,
                      width: '100%',
                      backgroundColor: 'var(--background)',
                      borderRadius: 5,
                      boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.06)'
                    }}
                    headStyle={{
                      border: 'none'
                    }}
                    bodyStyle={{
                      padding: '0 24px 18px'
                    }}
                  >
                    <Descriptions layout="horizontal" bordered={true} column={1}>
                      {
                        versionChanges.map((item, index) ->
                          <Descriptions.Item
                            label={<Tag color={item.color}>{ item.type }</Tag>}
                            key="#{ item.type }-#{ index }"
                            span={1}
                          >
                            <li style={{ listStyle: 'initial', listStyleType: 'none' }}>{ item.text }</li>
                          </Descriptions.Item>
                        )
                      }
                    </Descriptions>
                  </Card>
                </Timeline.Item>
              )
            }
          </Timeline>
        </TabPane>
        {
          changelistObjs.map((list) ->
            <TabPane tab={list.tabTitle} key={list.tabTitle}>
              <ChangelogList changelistUrl={list.url} keyId={list.keyId} hasCurrentVersion={list.hasCurrentVersion}/>
            </TabPane>
          )
        }
      </Tabs>
    </Modal>
  </>


export default connect(({ explore }) ->
  {
    hideChangelog: explore.hideChangelog
  }
)(ChangelogButton)